import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Box } from '@mui/material';
import { AuthProvider } from './contexts/AuthContext';
import { LanguageProvider } from './contexts/LanguageContext';
import Layout from './components/Layout/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Users from './pages/Users';
import Files from './pages/Files';
import Devices from './pages/Devices';
import Projects from './pages/Projects';
import ProtectedRoute from './components/Auth/ProtectedRoute';
import AdminRoute from './components/Auth/AdminRoute';

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <Box>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
              <Route index element={<Navigate to="/dashboard" replace />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="users" element={<AdminRoute><Users /></AdminRoute>} />
              <Route path="files" element={<Files />} />
              <Route path="devices" element={<Devices />} />
              <Route path="projects" element={<Projects />} />
            </Route>
          </Routes>
        </Box>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
